module.exports = __webpack_public_path__ + "img/palacowy.3debd773.jpg";